import { StyledSpin } from './Spin.styled'

const Spin = ({ ...props }) => {
  return <StyledSpin {...props} />
}

export default Spin
